"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagramGameplayComponentPropsFactory = void 0;
const GameplayComponentPropsFactory_1 = require("./GameplayComponentPropsFactory");
const asset_key_generator_1 = require("../../asset_key_generator");
const types_1 = require("../../gameplay/types");
class DiagramGameplayComponentPropsFactory extends GameplayComponentPropsFactory_1.GameplayComponentPropsFactory {
    createQuestionTextProps() {
        if (this.card.cardQuestion.questionText) {
            const props = {
                text: this.card.cardQuestion.questionText,
                className: 'questionText-text',
                gameplayStyle: this.style,
            };
            return props;
        }
        return undefined;
    }
    createQuestionChoiceProps() {
        const answerTexts = this.card.cardAnswer.answerTexts;
        const diagram = this.card.diagram;
        if (!diagram || answerTexts.length === 0) {
            return undefined;
        }
        const diagramFileName = diagram.fileName;
        const diagramTitle = diagram.title;
        const zoomInScale = diagram.zoomInScale;
        const key = asset_key_generator_1.AssetKeyGenerator.key(diagramFileName, asset_key_generator_1.AssetType.Diagram);
        const downloadUrl = this.fileUrls.get(key);
        if (!downloadUrl) {
            return undefined;
        }
        const targetDetectionId = answerTexts[0];
        let hideForegroundDrawing = false;
        if (this.card.gameplayInfo.name === types_1.Gameplay.DiagramGameplay001) {
            hideForegroundDrawing = false;
        }
        else if (this.card.gameplayInfo.name === types_1.Gameplay.DiagramGameplay002) {
            hideForegroundDrawing = true;
        }
        const props = {
            src: downloadUrl,
            fileName: diagramFileName,
            title: diagramTitle !== null && diagramTitle !== void 0 ? diagramTitle : '',
            targetDetectionId: targetDetectionId,
            highlightIds: [],
            hideForegroundDrawing: hideForegroundDrawing,
            zoomInScale: zoomInScale,
            className: 'questionChoice-diagram',
            gameplayStyle: this.style,
            offsetX: 0,
            offsetY: 0,
        };
        return props;
    }
}
exports.DiagramGameplayComponentPropsFactory = DiagramGameplayComponentPropsFactory;
